export default {"src":"/_next/static/media/logo-interactive-brokers-white-stacked.6451d904.svg","height":79,"width":228,"blurWidth":0,"blurHeight":0};